import { render, staticRenderFns } from "./aboutDia.vue?vue&type=template&id=59a95862&scoped=true&"
import script from "./aboutDia.vue?vue&type=script&lang=js&"
export * from "./aboutDia.vue?vue&type=script&lang=js&"
import style0 from "./aboutDia.vue?vue&type=style&index=0&id=59a95862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a95862",
  null
  
)

export default component.exports